import { mapValuesKey } from "../helpers/helpers";
import authStore from "./core/authStore";
import coreStore from "./core/coreStore";
import filterStore from "./core/filterStore";
import ambassadorsStore from "./features/ambassadorsStore";

// Global store
export const rootStore = {
  // Core
  core: coreStore, // Used for routing, resetting store
  auth: authStore,
  filter: filterStore,
  ambassadors: ambassadorsStore
};

// Global hook selectors
export const useStore = () => mapValuesKey("use", rootStore);

// Global tracked hook selectors
export const useTrackedStore = () => mapValuesKey("useTracked", rootStore);

// Global getter selectors
export const store = mapValuesKey("get", rootStore);

// Global actions
export const actions = mapValuesKey("set", rootStore);
